import { render, staticRenderFns } from "./AllergiesSection.vue?vue&type=template&id=058c1e6c&scoped=true&lang=pug&"
import script from "./AllergiesSection.vue?vue&type=script&lang=js&"
export * from "./AllergiesSection.vue?vue&type=script&lang=js&"
import style0 from "./AllergiesSection.vue?vue&type=style&index=0&id=058c1e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058c1e6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VSimpleTable,VTextField})
